import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { PaymentConfiguration } from "../../../types/PaymentConfigurationTypes";
import { toast } from "react-toastify";

// Async Thunks
export const fetchPaymentConfiguration = createAsyncThunk<PaymentConfiguration, void, { rejectValue: string }>("paymentConfiguration/fetchPaymentConfiguration", async (_, { rejectWithValue }) => {
    try {
        const response = await api.get<ApiResponse<PaymentConfiguration>>(apiEndpoints.payment.getPaymentDueDays);
        if (response?.success) {
            return response.data;
        } else {
            throw new Error(response.message || "Failed to fetch payment configuration.");
        }
    } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const createPaymentConfiguration = createAsyncThunk<PaymentConfiguration, PaymentConfiguration, { rejectValue: string }>("paymentConfiguration/createPaymentConfiguration", async (data, { rejectWithValue }) => {
    try {
        const response = await api.post<ApiResponse<PaymentConfiguration>>(apiEndpoints.payment.createPaymentDueDays, { data });
        if (response?.success) {
            toast.success("Payment due days create successfully");
            return response.data;
        } else {
            throw new Error(response.message || "Failed to add payment configuration.");
        }
    } catch (error: any) {
        return rejectWithValue(error.message);
    }
});

export const updatePaymentConfiguration = createAsyncThunk<PaymentConfiguration, PaymentConfiguration, { rejectValue: string }>("paymentConfiguration/updatePaymentConfiguration", async (updatedPaymentConfigurationData, { rejectWithValue }) => {
    try {
        const response = await api.put<ApiResponse<PaymentConfiguration>>(`${apiEndpoints.payment.updatePaymentDueDays}/${updatedPaymentConfigurationData?.id}`, { data: updatedPaymentConfigurationData });
        if (response?.success) {
            toast.success("Payment due days updated successfully");
            return { ...response.data };
        } else {
            throw new Error(response.message || "Failed to update payment configuration.");
        }
    } catch (error: any) {
        return rejectWithValue(error.message);
    }
});
